import { DocumentationGroupBehavior, ElementGroup, } from "@supernova-studio/model";
import { DTODocumentationGroupApprovalState } from "../../documentation";
import { DTODocumentationDraftState } from "./draft-state";
import { DTODocumentationItemConfigurationV2 } from "./item-configuration-v2";
import { DTODocumentationPublishMetadata } from "./metadata";
import { z } from "zod";
//
// Read
//
export const DTODocumentationGroupV2 = ElementGroup.omit({
    sortOrder: true,
    parentPersistentId: true,
    brandPersistentId: true,
    meta: true,
    childType: true,
    data: true,
    shortPersistentId: true,
}).extend({
    title: z.string(),
    isRoot: z.boolean(),
    childrenIds: z.array(z.string()),
    groupBehavior: DocumentationGroupBehavior,
    shortPersistentId: z.string(),
    configuration: DTODocumentationItemConfigurationV2,
    type: z.literal("Group"),
    /** Defined when a group has changed since last publish and can be included into a partial publish */
    draftState: DTODocumentationDraftState.optional(),
    /** Defined if a group was published at least once and contains metadata about last publish */
    publishMetadata: DTODocumentationPublishMetadata.optional(),
    //** An approval state for frontend to utilize. */
    approvalState: DTODocumentationGroupApprovalState.optional(),
});
//
// Write
//
export const DTOCreateDocumentationGroupInput = z.object({
    // Identifier
    persistentId: z.string(),
    // Group properties
    title: z.string(),
    configuration: DTODocumentationItemConfigurationV2.partial().optional(),
    // Group placement properties
    afterPersistentId: z.string().nullish(),
    parentPersistentId: z.string(),
});
export const DTOUpdateDocumentationGroupInput = z.object({
    // Identifier of the group to update
    id: z.string(),
    // Group properties
    title: z.string().optional(),
    configuration: DTODocumentationItemConfigurationV2.partial().optional(),
});
export const DTOMoveDocumentationGroupInput = z.object({
    // Identifier of the group to update
    id: z.string(),
    // Group placement properties
    parentPersistentId: z.string(),
    afterPersistentId: z.string().nullish(),
});
export const DTODuplicateDocumentationGroupInput = z.object({
    // Identifier of the group to duplicate from
    id: z.string(),
    // New group persistent id
    persistentId: z.string(),
    // Group placement properties
    afterPersistentId: z.string().nullish(),
    parentPersistentId: z.string(),
});
export const DTOCreateDocumentationTabInput = z.object({
    // New group persistent id
    persistentId: z.string(),
    // If this is page, we will attempt to convert it to tab
    // If this is tab group, we will add a new tab to it
    fromItemPersistentId: z.string(),
    tabName: z.string(),
});
export const DTODeleteDocumentationTabGroupInput = z.object({
    // Deleted group id
    id: z.string(),
});
export const DTODeleteDocumentationGroupInput = z.object({
    // Identifier
    id: z.string(),
    // Deletion options
    deleteSubtree: z.boolean().default(false),
});
